import { createTheme, Switch } from "@mantine/core";
const theme = createTheme({
  components: {
    Switch: Switch.extend({
      defaultProps: {
        color: "#FB6514",
      },
    }),
  },
  fontFamily: "Outfit, sans-serif",
});

export default theme;
